import React from "react"
import ReactDOM from "react-dom"

import PointBuyHelper from "./components/PointBuyHelper"

document.addEventListener("DOMContentLoaded", () => {
    if(document.querySelector("#pointbuyHelper")) {
        ReactDOM.render(<PointBuyHelper/>, document.getElementById("pointbuyHelper"));
    }
});
